<template>
    <section id="app">

            <div class="loading-wrapper"
                 v-if="schedule.error || startAvailableDate.error || addressItems.error">
                Возникла ошибка при попытке загрузить
            </div>
            <div v-else>
                <div v-if="!schedule.loading && !startAvailableDate.loading && !addressItems.loading">
                    <schedule/>
                </div>
                <div class="loading-wrapper"
                     v-else
                >
                    <svg version="1.1"
                         id="L9"
                         xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         x="0px"
                         y="0px"
                         viewBox="0 0 100 100"
                         enable-background="new 0 0 0 0"
                         xml:space="preserve"
                    >
                    <path fill="#fff"
                          d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                    >
                        <animateTransform attributeName="transform"
                                          attributeType="XML"
                                          type="rotate"
                                          dur="1s"
                                          from="0 50 50"
                                          to="360 50 50"
                                          repeatCount="indefinite"/>
                    </path>
                </svg>
                </div>
            </div>
    </section>
</template>

<script>
  import ScheduleFilter from "./components/ScheduleFilter";
  import Schedule from "./components/Schedule";
  import {mapState, mapActions, mapGetters} from 'vuex'

  export default {
    name: 'app',
    components: {Schedule, ScheduleFilter},
    computed: {
      ...mapState([
        'schedule',
        'urlDate',
        'filterDate',
        'filterAddress',
        'filterSearch',
        'startAvailableDate',
        'addressItems'
      ]),
      ...mapGetters([
        'getFilteredScheduleList'
      ])
    },
    created() {
      this.getSchedule();
      this.getStartAvailableDate();
      this.getAddress();

      //разбор url
      let searchDataVal;
      let searchDataArr;
      let searchDataObj = {};
      searchDataVal = window.location.search;
      if (searchDataVal) {
        searchDataArr = (searchDataVal.substr(1)).split('&');
        searchDataArr.forEach(item => {
          const itemArrSting = item.split('=');
          if (itemArrSting[0] === 'search') {
            searchDataObj[itemArrSting[0]] = itemArrSting[1];
          } else {
            searchDataObj[itemArrSting[0]] = itemArrSting[1].split(',');
          }
        });
          let formatDate = searchDataObj.date.map(item => new Date(new Date(Number(item)).getFullYear(), new Date(Number(item)).getMonth(), new Date(Number(item)).getDate()).getTime());
          searchDataObj.date = formatDate
          this.setURL(searchDataObj);
      }
    },
    methods: {
      ...mapActions([
        'getSchedule',
        'setURL',
        'getStartAvailableDate',
        'getAddress'
      ])
    }
  }
</script>

<style lang="scss">
    @import "style/colors";
</style>

<style lang="scss" scoped>
    .loading-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--background);
        height: 500px;
        width: 100%;

        svg {
            width: 100px;
            height: 100px;
            margin: 20px;
            display: inline-block;
        }
    }
</style>
